import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const domainConfigSlice = createSlice({
	name: 'domainConfig',
	initialState,
	reducers: {
		setDomainData: (state, action) => {
			state.data = action.payload;
			state.loading = false;
			state.error = null;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		clearDomainData: (state) => {
			state.data = null;
			state.loading = false;
			state.error = null;
		},
	},
});

export const { setDomainData, setLoading, setError, clearDomainData } = domainConfigSlice.actions;
export default domainConfigSlice.reducer;